import camelcaseKeys from 'camelcase-keys'

/* eslint-disable max-lines */
export const overviewDummyData = camelcaseKeys({
  llm_summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  traffic: {
    average_traffic: {
      year: 2024,
      catchment: {
        mode: 'line',
        length: 250,
      },
      percentage_diff_daily_average: 10.36,
      daily_average_unique_traffic: 11501,
      monthly: [
        {
          month: 1,
          avg_daily: 13903,
        },
        {
          month: 2,
          avg_daily: 9680,
        },
        {
          month: 3,
          avg_daily: 10213,
        },
        {
          month: 4,
          avg_daily: 8722,
        },
        {
          month: 5,
          avg_daily: 10900,
        },
        {
          month: 6,
          avg_daily: 11525,
        },
        {
          month: 7,
          avg_daily: 14156,
        },
        {
          month: 8,
          avg_daily: 12275,
        },
        {
          month: 9,
          avg_daily: 11638,
        },
        {
          month: 10,
          avg_daily: 10888,
        },
        {
          month: 11,
          avg_daily: 11413,
        },
        {
          month: 12,
          avg_daily: 12697,
        },
      ],
    },
    map: {
      catchment: {
        mode: 'line',
        length: 250,
        coordinates: [
          [
            [
              19.394662,
              53.2632,
            ],
            [
              19.394442,
              53.26319,
            ],
            [
              19.393976,
              53.26297,
            ],
            [
              19.393768,
              53.262864,
            ],
            [
              19.393662,
              53.262827,
            ],
            [
              19.393285,
              53.262347,
            ],
            [
              19.393252,
              53.26197,
            ],
            [
              19.393141,
              53.261491,
            ],
            [
              19.392662,
              53.261103,
            ],
            [
              19.392378,
              53.261254,
            ],
            [
              19.392099,
              53.261408,
            ],
            [
              19.391662,
              53.261624,
            ],
            [
              19.391295,
              53.261603,
            ],
            [
              19.390786,
              53.261846,
            ],
            [
              19.390662,
              53.261821,
            ],
            [
              19.39043,
              53.261202,
            ],
            [
              19.390026,
              53.26097,
            ],
            [
              19.389852,
              53.26078,
            ],
            [
              19.389662,
              53.260614,
            ],
            [
              19.389336,
              53.260296,
            ],
            [
              19.388781,
              53.25997,
            ],
            [
              19.388948,
              53.259684,
            ],
            [
              19.389053,
              53.259362,
            ],
            [
              19.389424,
              53.259208,
            ],
            [
              19.389662,
              53.259055,
            ],
            [
              19.389705,
              53.259013,
            ],
            [
              19.389763,
              53.25897,
            ],
            [
              19.39034,
              53.258648,
            ],
            [
              19.390662,
              53.258257,
            ],
            [
              19.39098,
              53.258288,
            ],
            [
              19.391209,
              53.258423,
            ],
            [
              19.391662,
              53.258437,
            ],
            [
              19.392156,
              53.258464,
            ],
            [
              19.392168,
              53.258464,
            ],
            [
              19.392662,
              53.258495,
            ],
            [
              19.392952,
              53.258261,
            ],
            [
              19.393247,
              53.25797,
            ],
            [
              19.393364,
              53.257672,
            ],
            [
              19.393662,
              53.257441,
            ],
            [
              19.39398,
              53.257288,
            ],
            [
              19.394294,
              53.25697,
            ],
            [
              19.394526,
              53.256835,
            ],
            [
              19.394662,
              53.256851,
            ],
            [
              19.394821,
              53.256812,
            ],
            [
              19.395378,
              53.256687,
            ],
            [
              19.395662,
              53.256611,
            ],
            [
              19.396109,
              53.256523,
            ],
            [
              19.3962,
              53.256509,
            ],
            [
              19.396662,
              53.25641,
            ],
            [
              19.39703,
              53.256339,
            ],
            [
              19.397556,
              53.25597,
            ],
            [
              19.397605,
              53.255914,
            ],
            [
              19.397662,
              53.255877,
            ],
            [
              19.39773,
              53.255902,
            ],
            [
              19.397844,
              53.25597,
            ],
            [
              19.398329,
              53.256303,
            ],
            [
              19.398662,
              53.256512,
            ],
            [
              19.398984,
              53.256648,
            ],
            [
              19.399604,
              53.25697,
            ],
            [
              19.399638,
              53.256994,
            ],
            [
              19.399662,
              53.257013,
            ],
            [
              19.400109,
              53.257523,
            ],
            [
              19.400431,
              53.25797,
            ],
            [
              19.400538,
              53.258094,
            ],
            [
              19.400662,
              53.258193,
            ],
            [
              19.401107,
              53.258416,
            ],
            [
              19.401176,
              53.258456,
            ],
            [
              19.401662,
              53.258633,
            ],
            [
              19.401863,
              53.258769,
            ],
            [
              19.40197,
              53.25897,
            ],
            [
              19.401871,
              53.25918,
            ],
            [
              19.401662,
              53.259357,
            ],
            [
              19.401362,
              53.259671,
            ],
            [
              19.401327,
              53.25997,
            ],
            [
              19.401348,
              53.260284,
            ],
            [
              19.401547,
              53.260856,
            ],
            [
              19.401561,
              53.26097,
            ],
            [
              19.401389,
              53.261243,
            ],
            [
              19.401262,
              53.26157,
            ],
            [
              19.400957,
              53.261675,
            ],
            [
              19.400662,
              53.261851,
            ],
            [
              19.400228,
              53.261404,
            ],
            [
              19.400112,
              53.26142,
            ],
            [
              19.399662,
              53.261295,
            ],
            [
              19.399349,
              53.261283,
            ],
            [
              19.399058,
              53.26097,
            ],
            [
              19.39887,
              53.260762,
            ],
            [
              19.398662,
              53.260716,
            ],
            [
              19.398495,
              53.260803,
            ],
            [
              19.398361,
              53.26097,
            ],
            [
              19.398128,
              53.261436,
            ],
            [
              19.397662,
              53.26167,
            ],
            [
              19.397442,
              53.26175,
            ],
            [
              19.397222,
              53.26197,
            ],
            [
              19.397035,
              53.262344,
            ],
            [
              19.396662,
              53.26253,
            ],
            [
              19.396277,
              53.262586,
            ],
            [
              19.396047,
              53.262586,
            ],
            [
              19.395662,
              53.262628,
            ],
            [
              19.395375,
              53.262684,
            ],
            [
              19.394975,
              53.26297,
            ],
            [
              19.394807,
              53.263115,
            ],
            [
              19.394662,
              53.2632,
            ],
          ],
        ],
      },
      map_data: {
        type: 'FeatureCollection',
        features: [],
      },
    },
    daily_traffic: {
      catchment: {
        mode: 'line',
        length: 250,
      },
      dayparts: [
        {
          daypart: 'night',
          share_pct: 8.3,
        },
        {
          daypart: 'lunch',
          share_pct: 31.6,
        },
        {
          daypart: 'afternoon',
          share_pct: 19.6,
        },
        {
          daypart: 'evening',
          share_pct: 10.4,
        },
        {
          daypart: 'morning',
          share_pct: 30.1,
        },
      ],
    },
    week_traffic: {
      catchment: {
        mode: 'line',
        length: 250,
      },
      week_parts: {
        weekdays: 12149,
        weekends: 9882,
      },
    },
  },
  population: {
    series: [
      {
        k: 0,
        approx_radius_m: 34.370003313743744,
        total: 4.0,
      },
      {
        k: 1,
        approx_radius_m: 152.2212770833012,
        total: 48.0,
      },
      {
        k: 2,
        approx_radius_m: 278.41645732711874,
        total: 194.0,
      },
      {
        k: 3,
        approx_radius_m: 405.5125180399596,
        total: 253.0,
      },
      {
        k: 4,
        approx_radius_m: 532.7957360338526,
        total: 483.0,
      },
      {
        k: 5,
        approx_radius_m: 660.1585678905982,
        total: 1031.0,
      },
      {
        k: 6,
        approx_radius_m: 787.5629793311076,
        total: 2240.0,
      },
      {
        k: 7,
        approx_radius_m: 914.9921093139673,
        total: 3845.0,
      },
      {
        k: 8,
        approx_radius_m: 1042.4373384554767,
        total: 5859.0,
      },
      {
        k: 9,
        approx_radius_m: 1169.893802287813,
        total: 7374.0,
      },
      {
        k: 10,
        approx_radius_m: 1298.4875567046092,
        total: 8118.0,
      },
      {
        k: 11,
        approx_radius_m: 1427.3814582459438,
        total: 9426.0,
      },
      {
        k: 12,
        approx_radius_m: 1556.2827271648296,
        total: 11030.0,
      },
    ],
    demography: {
      catchment: {
        mode: 'line',
        length: 250,
      },
      average_age: 43.7,
      age_buckets: [
        {
          order: 1,
          age_range: '0-15',
          share: 17.0,
          value: 995,
          female: {
            value: 475,
            share: 47.7,
          },
          male: {
            value: 520,
            share: 52.3,
          },
        },
        {
          order: 2,
          age_range: '16-24',
          share: 5.7,
          value: 332,
          female: {
            value: 168,
            share: 50.6,
          },
          male: {
            value: 164,
            share: 49.4,
          },
        },
        {
          order: 3,
          age_range: '25-44',
          share: 28.9,
          value: 1693,
          female: {
            value: 859,
            share: 50.7,
          },
          male: {
            value: 834,
            share: 49.3,
          },
        },
        {
          order: 4,
          age_range: '45-64',
          share: 26.0,
          value: 1523,
          female: {
            value: 804,
            share: 52.8,
          },
          male: {
            value: 719,
            share: 47.2,
          },
        },
        {
          order: 5,
          age_range: '65+',
          share: 22.5,
          value: 1316,
          female: {
            value: 762,
            share: 57.9,
          },
          male: {
            value: 554,
            share: 42.1,
          },
        },
      ],
    },
  },
  income: {
    catchment: {
      mode: 'line',
      length: 250,
    },
    avg_income: 3322,
    avg_voiv_income: 3586,
    income_vs_voiv_pct: 150,
  },
}, {
  deep: true,
})
